import { RouteType } from "types/RouteType";
import MeetingSourcesStore from "./MeetingSourcesStore";

const meetingSourcesRoute: RouteType[] = [
  {
    name: "MeetingSources",
    path: "/meeting-sources",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Meeting Sources",
        enableRefreshButton: true,
        component: () => import("./MeetingSources.Header"),
      },
      body: {
        component: () => import("./MeetingSources.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    searchAliases: ["read.ai", "read ai", "ingest"],
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      (rootStore.meetingSourcesStore as MeetingSourcesStore)?.load();
    },
  },
];

export default meetingSourcesRoute;
